document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-octa-events]').forEach((root) => {
    const form = root.querySelector('.octa-lead-form');
    const leadCard = root.querySelector('.octa-lead-card');
    const venueSelect = root.querySelector('[data-octa-venue-select]');

    const scrollToForm = () => {
      leadCard?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    root.querySelectorAll('[data-octa-scroll-form]').forEach((button) => {
      button.addEventListener('click', scrollToForm);
    });

    root.querySelectorAll('[data-octa-venue]').forEach((button) => {
      button.addEventListener('click', () => {
        const requestedVenue = button.dataset.octaVenue || '';
        const matchingOption = Array.from(venueSelect?.options || []).find(
          (option) => option.value.toLowerCase() === requestedVenue.toLowerCase(),
        );
        if (matchingOption && venueSelect) venueSelect.value = matchingOption.value;
        scrollToForm();
      });
    });

    if (!form || form.querySelector('[data-octa-success]')) return;

    const stepOne = form.querySelector('[data-octa-step="1"]');
    const stepTwo = form.querySelector('[data-octa-step="2"]');
    const nextButton = form.querySelector('[data-octa-next]');
    const previousButton = form.querySelector('[data-octa-previous]');
    const stepCount = root.querySelector('[data-octa-step-count]');
    const progress = root.querySelector('[data-octa-progress]');
    const stepError = form.querySelector('[data-octa-step-error]');

    const setStep = (step, shouldFocus = true) => {
      const isSecondStep = step === 2;
      stepOne.hidden = isSecondStep;
      stepTwo.hidden = !isSecondStep;
      if (stepCount) stepCount.textContent = String(step);
      progress?.classList.toggle('is-complete', isSecondStep);
      if (isSecondStep && shouldFocus) {
        window.setTimeout(() => stepTwo.querySelector('input, select')?.focus(), 180);
      }
    };

    const syncChoiceState = () => {
      form.querySelectorAll('.octa-choice-grid label').forEach((label) => {
        label.classList.toggle('is-selected', Boolean(label.querySelector('input:checked')));
      });
      const ready = Boolean(
        form.querySelector('input[name="contact[Typ eventu]"]:checked') &&
          form.querySelector('input[name="contact[Počet hostí]"]:checked'),
      );
      if (nextButton) nextButton.disabled = !ready;
      if (ready && stepError) stepError.hidden = true;
    };

    form.addEventListener('change', syncChoiceState);
    nextButton?.addEventListener('click', () => {
      if (nextButton.disabled) {
        if (stepError) stepError.hidden = false;
        return;
      }
      setStep(2);
    });
    previousButton?.addEventListener('click', () => setStep(1));

    const startsOnStepTwo = Boolean(stepOne?.hidden && !stepTwo?.hidden);
    setStep(startsOnStepTwo ? 2 : 1, false);
    syncChoiceState();
  });
});
